import AjaxLoader from "../../../utils/ajax_loader.coffee"
import translations from "../../../translations"
import * as I18n from "../../../services/i18n"

export default class Steps
  @add_listeners: ->
    $('.approve-plannings').hide()
    $('.approve-plannings-checkbox-div').hide()

    $('#js_planning_step_weight').off().on 'input', ->
      $input = $(this)
      val = $input.val()
      cursorPos = this.selectionStart
      originalCursorPos = cursorPos

      cleanVal = val.replace(/[^0-9.,]/g, '')

      if cleanVal.includes(',')
        cleanVal = cleanVal.replace(',', '.')

      dotCount = (cleanVal.match(/\./g) || []).length
      if dotCount > 1
        firstDotIndex = cleanVal.indexOf('.')
        cleanVal = cleanVal.substring(0, firstDotIndex + 1) + cleanVal.substring(firstDotIndex + 1).replace(/\./g, '')

      if cleanVal.includes('.')
        parts = cleanVal.split('.')
        if parts[1] && parts[1].length > 2
          cleanVal = parts[0] + '.' + parts[1].substring(0, 2)

      if cleanVal != '' && !isNaN(cleanVal)
        numVal = parseFloat(cleanVal)
        if numVal < 1 && cleanVal.length > 0 && cleanVal != '0'
          cleanVal = '1'

      if cleanVal != val
        $input.val(cleanVal)
        setTimeout ->
          $input[0].setSelectionRange(originalCursorPos, originalCursorPos)
        , 0
    $('.btn.new-step').off().on 'click', ->
      Error.clear_global_errors()
      $('#js_create_group').hide()
      form = $('#form_step_lightbox form')[0]
      clean_inputs()
      form.action = "/plannings/steps"
      form.method = "POST"
      $('#js_input_method_container').html('')
      modal_title = $('#form_step_lightbox .modal-title-small')[0]
      modal_title.textContent = I18n.t(translations(), 'plannings.steps.form.title')

    $('.edit-step').off().on 'click', ->
      Error.clear_global_errors()
      form = $('#form_step_lightbox form')[0]
      clean_inputs()
      step_data = $(@).data('step')
      modal_title = $('#form_step_lightbox .modal-title-small')[0]
      modal_title.textContent = I18n.t(translations(), 'plannings.steps.form.edit_title')
      form.action = "/plannings/steps/#{step_data.id}"
      form.method = "POST"
      $('#js_input_method_container').html('<input type="hidden" name="_method" value="PUT">')
      $('#js_planning_step_notify').on 'change', ->
        container = $('#js_planning_step_people_to_notify_container')
        if $(this).prop('checked')
          container.show()
        else
          container.hide()
      fill_fields(step_data)
      select_right_option(step_data)
      toggle_create_micro()
    $('.js-btn-approve-step-plannings').off().on 'click', ->
      button_id = $(this)[0].id
      step_id = button_id.slice(button_id.lastIndexOf("-") + 1)
      $('#js-approve-plannings-div-' + step_id).toggle()
      $('.js-approve-plannings-checkbox-div-' + step_id).toggle()
      $('#js-select-all-plannings-checkbox-' + step_id).on 'change', ->
        checked = $(this).prop('checked')
        text = if checked then I18n.t(translations(), 'plannings.steps.index.unselect_all_plannings') \
          else I18n.t(translations(), 'plannings.steps.index.select_all_plannings')
        $('#js-select-all-plannings-text-' + step_id).text(text)
        $('.js-approve-plannings-checkbox-div-' + step_id + ' input[type="checkbox"]').prop('checked', checked)

    fill_fields = (step_data) ->
      $('#js_planning_step_name').val(step_data.name)
      $('#js_planning_step_start_at').val(step_data.start_at)
      $('#js_planning_step_finish_at').val(step_data.finish_at)
      $('#js_planning_step_observation').val(step_data.observation)
      $('#js_planning_step_notify').prop('checked', step_data.notify).trigger('change')
      # js_planning_step_weight
      $('#js_planning_step_weight').val(step_data.weight)
      if step_data.people_to_notify?
        ids = step_data.people_to_notify.map (person) -> person.id
        $('#js_planning_step_people_to_notify').val(ids).trigger('change')


    select_right_option = (step_data) ->
      $('#js_planning_step_responsible_company_id').val(step_data.responsible_company_id)
      $('.js_macro_select').val(step_data.macro_id)
      $('.js_macro_select').trigger 'change', [step_data.group_id]

    toggle_create_micro = ->
      $('#js_create_group').hide() unless $('.js_macro_select').val()
      $('#js_create_group').show() if $('.js_macro_select').val()

    $('#js_atividade_step_form').on 'ajax:send', ->
      $('button.js-step-save').attr('disabled', true)
      new AjaxLoader('loader-spinner').hide()
      new AjaxLoader('step-save').show()

    $('#js_atividade_step_form').on 'ajax:complete', (event) ->
      [xhr, status] = event.detail
      unless xhr.responseText.substring(0, 15) == 'window.location'
        $('button.js-step-save').attr('disabled', false)
        new AjaxLoader('step-save').hide()

  @save_step: (id) ->
    Error.clear_global_errors()

    $("#step-form-#{id} #atividade_step_name").prop('disabled', true)
    toggle_elements(id)

  toggle_elements = (id) ->
    $("#step-form-#{id} #atividade_step_name").focus()
    $("#step-options-#{id}").toggle()
    $("#step-form-options-#{id}").toggle()

  clean_inputs = ->
    $('#js_planning_step_name').val('')
    $('#js_planning_step_start_at').val('')
    $('#js_planning_step_finish_at').val('')
    $('#js_planning_step_observation').val('')
    $('.js_macro_select').val('')
    $('.js_group_select').val('')
    $('#js_planning_step_responsible_company_id').val('')
    $('#js_planning_step_notify').prop('checked', false).trigger('change')
    $('#js_planning_step_people_to_notify').val([])
    $('#js_planning_step_weight').val('')
